import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';

export const eventApi = createApi({
  reducerPath: 'eventApi',
  refetchOnMountOrArgChange: false, // dedup SSR<->cliente: usar la cache hidratada del SSR, no re-fetchear simple-info en cada mount
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_API_CHECKOUT}`,
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  tagTypes: ['Events', 'eventSearch'],
  keepUnusedDataFor: 30,
  endpoints: (build) => ({
    getEventsByIdOrName: build.query({
      query: (value) => ({
        url: `events-core/api/v1/events/subdomains/${value.subdomain}`,
        headers: {
          ...(value.link ? { link: value.link } : {}),
        },
      }),
      providesTags: ['eventSearch'],
      keepUnusedDataFor: 0,
    }),
    getEventResumeByNamePublic: build.query({
      query: (value) => `events-core/api/v1/events/simple-info/${value}`,
      providesTags: ['eventInfoSearch'],
      keepUnusedDataFor: 30,
    }),
    getEventResumeByNamePrivate: build.query({
      query: (value) => `${process.env.NEXT_PUBLIC_API_PRIVATE_CHECKOUT}/events-core/api/v1/events/simple-info/${value}`,
      providesTags: ['eventInfoSearch'],
      keepUnusedDataFor: 30,
    }),
  }),
});

export const {
  useGetEventsByIdOrNameQuery,
  useLazyGetEventsByIdOrNameQuery,
  useGetEventResumeByNamePublicQuery,
  useLazyGetEventResumeByNamePublicQuery,
  useGetEventResumeByNamePrivateQuery,
  useLazyGetEventResumeByNamePrivateQuery,
  util: { getRunningQueriesThunk },
} = eventApi;

export const { getEventResumeByNamePrivate, getEventResumeByNamePublic } = eventApi.endpoints;
